import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl";
import { Modal, Button, ModalHeader, ModalFooter, Form, InputGroup, FormControl } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Swal from "sweetalert2";
import {
    useReactTable,
    getCoreRowModel,
    getFilteredRowModel,
    getPaginationRowModel,
    getSortedRowModel,
    flexRender,
} from "@tanstack/react-table";
import "./user.css";

function Menu({ refresh }) {
    const [data, setData] = useState([]);
    const accessuserid = localStorage.getItem("id");
    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [edshowModal, setedShowModal] = useState(false);
    const [pgm, setpgm] = useState([]);
    const [pgm_menu, setpgm_menu] = useState("");
    const [pgm_url, setpgm_url] = useState("");
    const [pgm_icon, setpgm_icon] = useState("");
    const [pgm_parent, setpgm_parent] = useState("");
    const [pgm_parentname, setpgm_parentname] = useState("");

    const [edpgm_menu, setedpgm_menu] = useState("");
    const [edpgm_url, setedpgm_url] = useState("");
    const [edpgm_icon, setedpgm_icon] = useState("");
    const [edserial, setedserial] = useState("");
    const [pgmId, setpgmId] = useState("");
    const [edpgm_parentname, setedpgm_parentname] = useState("");
    const [menu, setmenu] = useState("");
    const [menuOptions, setmenuOptions] = useState([]);
    const [menu_status, setmenu_status] = useState("");
    const [x, setX] = useState("");
    const [xy, setXY] = useState("");
    const [refreshSidebar, setRefreshSidebar] = useState(false);

    // TanStack Table state
    const [sorting, setSorting] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");

    const handleRefreshSidebar = () => {
        setRefreshSidebar(prev => !prev);
    };

    const handleclick = () => {
        setShowModal(true);
        getprms();
    };

    const getprms = () => {
        axios
            .get(baseurladdress + "menu/getprograms", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const raw = res.data.programs;
                    const formatted = raw.map((p) => ({
                        id: p.pgm_id,
                        name: p.pgm_menu,
                        icon: p.pgm_icon,
                        parent: p.pgm_parent,
                        url: p.pgm_url,
                    }));
                    setpgm(formatted);
                } else {
                    setpgm([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching programs:", error);
            });
    };

    const GetAllmenu = () => {
        axios
            .get(baseurladdress + "menu/findallmenu", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    setData(res.data.menu);
                } else {
                    setData([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching menu:", error);
            });
    };

    useEffect(() => {
        GetAllmenu();
    }, [refresh]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            pgm_menu: pgm_menu,
            pgm_url: pgm_url,
            pgm_icon: pgm_icon,
            pgm_parent: pgm_parent || 0,
            pgm_parentname: pgm_parentname || "#",
            pgm_crtdby: accessuserid,
        };

        axios
            .post(baseurladdress + "menu/addmenu", data, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    });

                    Toast.fire({
                        icon: "success",
                        title: res.data.message || "Menu added successfully",
                    });

                    handleRefreshSidebar();
                    setShowModal(false);
                    setpgm_menu("");
                    setpgm_url("");
                    setpgm_icon("");
                    setpgm_parent("");
                    setpgm_parentname("");
                    GetAllmenu();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed",
                        text: res.data.message || "Menu could not be added",
                    });
                }
            })
            .catch((error) => {
                console.error("Error adding menu:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Something went wrong while adding the menu.",
                });
            });
    };

    const getmenu = () => {
        axios
            .get(baseurladdress + "menu/findallmenu", {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success") {
                    const data = res.data.menu;
                    const formattedOptions = data.map((item) => ({
                        id: item.pgm_id,
                        name: item.pgm_menu,
                    }));
                    setmenuOptions(formattedOptions);
                } else {
                    setmenuOptions([]);
                }
            })
            .catch((error) => {
                console.error("Error fetching menu:", error);
            });
    };

    useEffect(() => {
        getmenu();
    }, []);

    const handleEditClick = (pgmId) => {
        setedShowModal(true);
        setpgmId(pgmId);

        axios
            .get(`${baseurladdress}menu/editmenu/${pgmId}`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
            .then((res) => {
                if (res.data.status === "Success" && res.data.menu.length > 0) {
                    const data = res.data.menu[0];

                    setedpgm_menu(data.pgm_menu);
                    setedpgm_url(data.pgm_url);
                    setedpgm_icon(data.pgm_icon);
                    setedserial(data.pgm_serial);
                    setmenu_status(data.pgm_status);
                    setXY(data.pgm_status);

                    const isActive = data.pgm_status === 1 || data.pgm_status === "1";
                    setX(isActive);


                    const parentId = data.pgm_parent;
                    if (parentId === 0 || parentId === data.pgm_id) {
                        setmenu(""); // Will show "Select Program" option
                        setedpgm_parentname("#");
                    } else {
                        setmenu(parentId);
                        setedpgm_parentname(data.pgm_parentname || "");
                    }
                }
            })
            .catch((error) => {
                console.error("Edit menu error:", error);
                alert("Failed to load menu details");
            });
    };

    const handleUpdate = (e) => {
        e.preventDefault();

        const data = {
            pgm_menu: edpgm_menu,
            pgm_url: edpgm_url,
            pgm_icon: edpgm_icon,
            pgm_serial: edserial,
            pgm_parent: menu || 0,
            pgm_parentname: menu ? edpgm_parentname : "#",
            pgm_status: menu_status,
            pgm_updtby: accessuserid,
            pgm_id: pgmId,
        };

        axios
            .post(baseurladdress + "menu/updatemenu", data, {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
            })
            .then((result) => {
                if (result.data.status === "Success") {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 2500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener("mouseenter", Swal.stopTimer);
                            toast.addEventListener("mouseleave", Swal.resumeTimer);
                        },
                    });
                    Toast.fire({
                        icon: "success",
                        title: "Menu updated successfully",
                    });
                    handleRefreshSidebar();
                    setedShowModal(false);
                    GetAllmenu();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "Failed",
                        text: result.data.message || "Update failed",
                    });
                }
            })
            .catch((error) => {
                console.error("Update error:", error);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Something went wrong while updating the menu.",
                });
            });
    };
    function handleDelete(pgmId) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .post(`${baseurladdress}menu/deletemenu/${pgmId}`, {}, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    })
                    .then((response) => {
                        const status = response.data.status;

                        if (status === "Success") {
                            Swal.fire({
                                toast: true,
                                position: "top-end",
                                icon: "success",
                                title: "Menu deleted successfully",
                                showConfirmButton: false,
                                timer: 2500,
                                timerProgressBar: true,
                            });

                            GetAllmenu(); // refresh menu list
                        } else {
                            Swal.fire("Error", "Menu not found", "error");
                        }
                    })
                    .catch((error) => {
                        Swal.fire(
                            "Error",
                            error.response?.data?.message || "Something went wrong",
                            "error"
                        );
                    });
            }
        });
    }

    // Define columns for TanStack Table
    const columns = useMemo(
        () => [
            {
                accessorKey: "index",
                header: "Sl.No",
                size: 60,
                cell: ({ row }) => row.index + 1,
            },
            {
                accessorKey: "pgm_menu",
                header: "Program Name",
                size: 150,
            },
            {
                accessorKey: "pgm_url",
                header: "URL",
                size: 150,
            },
            {
                accessorKey: "pgm_icon",
                header: "Icon",
                size: 120,
                cell: ({ row }) => (
                    <div>
                        <i
                            className={`fa ${row.original.pgm_icon}`}
                            style={{ marginRight: "8px", color: "brown" }}
                        ></i>
                        {row.original.pgm_icon}
                    </div>
                ),
            },
            {
                accessorKey: "pgm_parentname",
                header: "Parent",
                size: 120,
                cell: ({ row }) => {
                    const item = row.original;
                    return item.pgm_parent === 0 || item.pgm_parent === item.pgm_id
                        ? "#"
                        : item.pgm_parentname?.trim() || "#";
                },
            },
            {
                accessorKey: "pgm_status",
                header: "Status",
                size: 100,
                cell: ({ row }) => (
                    <div>
                        {row.original.pgm_status === 0 && (
                            <span className="badge bg-danger">Inactive</span>
                        )}
                        {row.original.pgm_status === 1 && (
                            <span className="badge bg-success">Active</span>
                        )}
                        {row.original.pgm_status === 2 && (
                            <span className="badge bg-warning">Active</span>
                        )}
                    </div>
                ),
            },
            {
                accessorKey: "actions",
                header: "Actions",
                enableSorting: false,
                cell: ({ row }) => (
                    <div className="d-flex gap-2">
                        <Icon.PencilSquare
                            className="text-primary"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleEditClick(row.original.pgm_id)}
                        />
                        <Icon.Trash
                            className="text-danger"
                            style={{ cursor: "pointer" }}
                            onClick={() => handleDelete(row.original.pgm_id)}
                        />
                    </div>
                ),
                size: 80,
            },
        ],
        []
    );

    // Create table instance
    const table = useReactTable({
        data: data,
        columns,
        state: {
            sorting,
            globalFilter,
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getFilteredRowModel: getFilteredRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: {
            pagination: {
                pageSize: 10,
            },
        },
    });

    return (
        <div>
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">
                        <section id="main-content">
                            <div className="card">
                                <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
                                    <h6 className="card-title"> MENU DETAILS</h6>
                                    <div className="d-flex align-items-center">
                                        <Button
                                            variant="light"
                                            size="sm"
                                            onClick={(e) => {
                                                handleclick();
                                                e.currentTarget.blur();
                                            }}
                                            className="d-flex align-items-center"
                                        >
                                            <Icon.Plus className="me-1" />
                                            Add
                                        </Button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    {/* Page Size and Search Controls */}
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div className="d-flex align-items-center gap-2">
                                            <span className="text-muted small">Show</span>
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "70px" }}
                                                value={table.getState().pagination.pageSize}
                                                onChange={(e) => {
                                                    table.setPageSize(Number(e.target.value));
                                                }}
                                            >
                                                {[5, 10, 20, 50].map((pageSize) => (
                                                    <option key={pageSize} value={pageSize}>
                                                        {pageSize}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            <span className="text-muted small">entries</span>
                                        </div>

                                        <InputGroup style={{ width: "250px" }}>
                                            <InputGroup.Text>
                                                <Icon.Search size={14} />
                                            </InputGroup.Text>
                                            <FormControl
                                                size="sm"
                                                placeholder="Search..."
                                                value={globalFilter ?? ""}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                            />
                                        </InputGroup>
                                    </div>

                                    {/* Table */}
                                    <div className="table-responsive">
                                        <table className="table table-hover table-sm align-middle">
                                            <thead className="table-light">
                                                {table.getHeaderGroups().map((headerGroup) => (
                                                    <tr key={headerGroup.id}>
                                                        {headerGroup.headers.map((header) => (
                                                            <th
                                                                key={header.id}
                                                                style={{ width: header.getSize() }}
                                                                className="text-nowrap"
                                                            >
                                                                {header.isPlaceholder ? null : (
                                                                    <div
                                                                        {...{
                                                                            className: header.column.getCanSort()
                                                                                ? "cursor-pointer select-none d-flex align-items-center"
                                                                                : "",
                                                                            onClick: header.column.getToggleSortingHandler(),
                                                                        }}
                                                                    >
                                                                        {flexRender(
                                                                            header.column.columnDef.header,
                                                                            header.getContext()
                                                                        )}
                                                                        {header.column.getCanSort() && (
                                                                            <span className="ms-1">
                                                                                {{
                                                                                    asc: <Icon.ChevronUp size={12} />,
                                                                                    desc: <Icon.ChevronDown size={12} />,
                                                                                }[header.column.getIsSorted()] ?? (
                                                                                        <Icon.ChevronExpand size={12} className="text-muted" />
                                                                                    )}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </th>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </thead>
                                            <tbody>
                                                {table.getRowModel().rows.length > 0 ? (
                                                    table.getRowModel().rows.map((row) => (
                                                        <tr key={row.id}>
                                                            {row.getVisibleCells().map((cell) => (
                                                                <td
                                                                    key={cell.id}
                                                                    style={{
                                                                        textAlign: "left",
                                                                        verticalAlign: "middle",
                                                                    }}
                                                                >
                                                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={columns.length} className="text-center text-muted py-4">
                                                            No menus found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Compact Pagination */}
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <div className="text-muted small">
                                            Showing {table.getState().pagination.pageIndex * table.getState().pagination.pageSize + 1} to{" "}
                                            {Math.min(
                                                (table.getState().pagination.pageIndex + 1) * table.getState().pagination.pageSize,
                                                table.getFilteredRowModel().rows.length
                                            )}{" "}
                                            of {table.getFilteredRowModel().rows.length} entries
                                        </div>

                                        <div className="btn-group btn-group-sm">
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => table.setPageIndex(0)}
                                                disabled={!table.getCanPreviousPage()}
                                            >
                                                <Icon.ChevronDoubleLeft size={14} />
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => table.previousPage()}
                                                disabled={!table.getCanPreviousPage()}
                                            >
                                                <Icon.ChevronLeft size={14} />
                                            </Button>
                                            <Button variant="outline-secondary" disabled>
                                                Page {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => table.nextPage()}
                                                disabled={!table.getCanNextPage()}
                                            >
                                                <Icon.ChevronRight size={14} />
                                            </Button>
                                            <Button
                                                variant="outline-secondary"
                                                onClick={() => table.setPageIndex(table.getPageCount() - 1)}
                                                disabled={!table.getCanNextPage()}
                                            >
                                                <Icon.ChevronDoubleRight size={14} />
                                            </Button>
                                        </div>
                                    </div>
                                </div>

                                {/* Add Modal */}
                                <Modal
                                    className="modal-size md modal-top-center"
                                    show={showModal}
                                    centered
                                    style={{ display: "flex" }}
                                    onHide={() => {
                                        setShowModal(false);
                                        document.activeElement.blur(); // removes focus from Add button
                                    }}
                                    backdrop="static"
                                    keyboard={false}
                                >
                                    <Modal.Header>
                                        <h6>ADD MENU</h6>
                                        <span
                                            aria-hidden="true"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowModal(false)}
                                        >
                                            ×
                                        </span>
                                    </Modal.Header>

                                    <Modal.Body className="css">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="col-md-6 mt-2">
                                                    <h6>Menu Name</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={pgm_menu}
                                                        onChange={(e) => setpgm_menu(e.target.value)}
                                                        placeholder="Enter menu name"
                                                        required
                                                    />
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <h6>URL</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={pgm_url}
                                                        onChange={(e) => setpgm_url(e.target.value)}
                                                        placeholder="Enter URL"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-6 mt-2">
                                                    <h6>Icon</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={pgm_icon}
                                                        onChange={(e) => setpgm_icon(e.target.value)}
                                                        placeholder="Enter icon class (e.g., fa-home)"
                                                    />
                                                </div>
                                                <div className="col-md-6 mt-2">
                                                    <h6>Program Name</h6>
                                                    <select
                                                        className="form-control"
                                                        value={pgm_parent}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            setpgm_parent(selectedId);
                                                            const selectedProgram = pgm.find(p => p.id.toString() === selectedId);
                                                            setpgm_parentname(selectedProgram ? selectedProgram.name : "#");
                                                        }}
                                                        required
                                                    >
                                                        <option value="">Select Program</option>
                                                        {pgm.map((p) => (
                                                            <option key={p.id} value={p.id}>{p.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </form>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <button
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={handleSubmit}
                                        >
                                            SAVE
                                        </button>
                                    </Modal.Footer>
                                </Modal>

                                {/* Edit Modal */}
                                <Modal
                                    className="modal-size md modal-top-center"
                                    show={edshowModal}
                                    centered
                                    onHide={() => setedShowModal(false)}
                                    backdrop="static"
                                    keyboard={false}
                                >
                                    <Modal.Header>
                                        <h6>EDIT MENU</h6>
                                        <span
                                            aria-hidden="true"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setedShowModal(false)}
                                        >
                                            ×
                                        </span>
                                    </Modal.Header>

                                    <Modal.Body className="css">
                                        <form onSubmit={(e) => e.preventDefault()}>
                                            <div className="row">
                                                <div className="col-md-6 mt-2">
                                                    <h6>Menu Name</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={edpgm_menu}
                                                        onChange={(e) => setedpgm_menu(e.target.value)}
                                                        placeholder="Enter menu name"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-6 mt-2">
                                                    <h6>URL</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={edpgm_url}
                                                        onChange={(e) => setedpgm_url(e.target.value)}
                                                        placeholder="Enter URL"
                                                        required
                                                    />
                                                </div>

                                                <div className="col-md-6 mt-2">
                                                    <h6>Icon</h6>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={edpgm_icon}
                                                        onChange={(e) => setedpgm_icon(e.target.value)}
                                                        placeholder="Enter icon class"
                                                    />
                                                </div>

                                                <div className="col-md-6 mt-2">
                                                    <h6>Serial</h6>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        value={edserial}
                                                        onChange={(e) => setedserial(e.target.value)}
                                                        placeholder="Enter serial"
                                                    />
                                                </div>

                                                <div className="col-md-6 mt-2">
                                                    <h6>Program Name</h6>
                                                    <select
                                                        className="form-control"
                                                        value={menu}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            const selectedItem = menuOptions.find(
                                                                (item) => item.id.toString() === selectedId
                                                            );
                                                            setmenu(selectedId);
                                                            setedpgm_parentname(selectedItem ? selectedItem.name : "#");
                                                        }}
                                                        required
                                                    >
                                                        <option value="">Select Program</option>
                                                        {menuOptions
                                                            .filter(item => item.id !== pgmId)
                                                            .map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>

                                                <div className="col-sm-4 mt-2 mt-sm-0">
                                                    <br />
                                                    <input
                                                        type="checkbox"
                                                        name="menu_status"
                                                        className="selectsingle checku"
                                                        checked={x}
                                                        value={xy}
                                                        id="exampleCheck1"
                                                        onClick={() => { setX(!x); }}
                                                        onChange={(event) => {
                                                            var checked = event.target.checked;
                                                            if (checked === true) {
                                                                setmenu_status(1);
                                                            } else {
                                                                setmenu_status(0);
                                                            }
                                                        }}
                                                    />
                                                    <label className="form__label textal offset-1" htmlFor="clienttype" style={{ fontSize: "15px" }}>
                                                        Status
                                                    </label>
                                                </div>
                                            </div>
                                        </form>
                                    </Modal.Body>

                                    <Modal.Footer>
                                        <button
                                            className="btn btn-primary"
                                            type="button"
                                            onClick={handleUpdate}
                                        >
                                            UPDATE
                                        </button>
                                    </Modal.Footer>
                                </Modal>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Menu;